<script setup lang="ts">

import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { IconContainer } from '@shared/ui/other'
import { LinkTextPrimaryMedium } from '@shared/ui/links'

import { useTaskRelationRelatedTo } from '../../model/task-relation-related-to.hook'

defineOptions({
  name: 'TaskRelationRelatedTo',
})

const {
  refHasRelatedTo,
  refHref,
  refLabel,
} = useTaskRelationRelatedTo()
</script>

<template>
  <LinkTextPrimaryMedium
    v-if="refHasRelatedTo"
    :href="refHref"
    target="_blank"
  >
    {{ refLabel }}
    <IconContainer>
      <FontAwesomeIcon :icon="faArrowUpRightFromSquare" />
    </IconContainer>
  </LinkTextPrimaryMedium>
  <template v-else>
    -
  </template>
</template>

<style scoped lang="scss" src="./TaskRelationRelatedTo.scss" />
